import React, { useState } from 'react';
import clsx from 'clsx';
import { useLocation, useSearchParams } from 'react-router-dom';
import IntroDetailsForm from './IntroDetailsForm';
import CustomLoader from 'components/CustomLoader';
import { useIntrosData } from './useIntrosData';
import './style.scss';

const Index = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const isTab = location.state?.token;
    const token = searchParams.get('token') || location.state?.token;
    const [loading, setLoading] = useState(true);
    const { favoriteFood, languages } = useIntrosData(token, setLoading);

    return (
        <CustomLoader active={loading}>
            <div className={clsx({ 'intro-form-container': !isTab })}>
                <div className='headline-2'>Complete Your Welcome Intro</div>
                <IntroDetailsForm
                    setSubmitLoader={setLoading}
                    isFavFoodEnabled={favoriteFood}
                    isLanguagesEnabled={languages}
                />
            </div>
        </CustomLoader>
    );
};

export default Index;
